import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import AppTooltip from "elements/AppTooltip";
import useFieldMap from "hooks/useFieldMap";
import { Dropdown } from "rsuite";
import { GetTableGroupBy } from "../../utils/QueryUtils";

// Options for the sort by dropdown menu
const LayoutsOptions = ({
  title,
  icon,
  onSelect,
  selectedLayout,
  selectedLayoutID,
  savedLayoutID,
  layouts = [],
  openManage,
  moduleAPIName,
  validPermissions,
  hideTitle,
}) => {
  const fieldMap = useFieldMap(moduleAPIName, "Name");

  return (
    <>
      <Dropdown.Menu style={{ width: "100%" }}>
        {!hideTitle && (
          <>
            <div className="d-flex align-items-center pt-1 pb-0">
              <i
                className={`mdi mdi-${icon} px-2 text-dark`}
                style={{ fontSize: 20 }}
              ></i>
              <h5 className="mb-0 text-dark flex-grow-1">{title}</h5>
            </div>
            <DropdownMenuDivider />
          </>
        )}
        {layouts?.map((l) => (
          <AppTooltip
            key={l.id}
            content={
              <>
                <div
                  className="border-bottom px-2 pt-1 font-weight-600 "
                  style={{ minWidth: 170 }}
                >
                  {l?.Name ?? "Layout"} Fields
                </div>
                <div className="px-2 pt-1 pb-2">
                  {l.Fields.map((f) => {
                    if (["id", "_RecordName"].includes(f)) return null;
                    return (
                      <div className="font-weight-500 text-truncate" key={f}>
                        {fieldMap?.[f] || f}
                      </div>
                    );
                  })}
                </div>
              </>
            }
          >
            <DropdownOptionWithIcon
              name={l.Name}
              onClick={() =>
                onSelect(l.id, { Fields: l.Fields, ...GetTableGroupBy(l) })
              }
              icon={`mdi mdi-${icon}`}
              active={
                selectedLayoutID
                  ? selectedLayoutID === l.id
                  : JSON.stringify(l.Fields) === JSON.stringify(selectedLayout)
              }
              isDefault={savedLayoutID === l.id}
            />
          </AppTooltip>
        ))}
        {layouts?.length < 1 && (
          <>
            <div
              className="py-2 text-xs border border-superlight rounded px-2 mb-2 bg-ultralight text-dark"
              style={{ whiteSpace: "pre-wrap", color: "var(--medium)" }}
            >
              Add your first Layout in the settings below to get started.
            </div>
          </>
        )}
        {!hideTitle && <DropdownMenuDivider />}
        <DropdownOptionWithIcon
          icon="mdi mdi-cog"
          name="Layouts Settings"
          disabled={!validPermissions}
          onClick={openManage}
        />
      </Dropdown.Menu>
    </>
  );
};

export default LayoutsOptions;
